export default {
  methods: {
    triggerFocus(idName) {
      $(`#${idName}`).focus()
    }
  }
}